import { STATEMENT_MAX_UPLOAD_SIZE_MB } from '@/modules/projects/constants'
import { BYTES_PER_MEGABYTE } from '@/modules/upload/constants'

export const CLOUD_FILE_SIZE_LIMIT_BYTES =
  STATEMENT_MAX_UPLOAD_SIZE_MB * BYTES_PER_MEGABYTE
